import cn from 'classnames'
import styles from './styles.module.css'


const SeasonCheckbox = ({
    count,
    onChange,
    className,
    color,
    value,
    name,
    id
}) => {
    const clickHandler = () => {
        onChange && onChange(id)
    }
    const classNames = cn(styles.checkbox, className, {
        [styles['checkbox_active']]: value
    })
    return <div className={styles['checkbox-container']}>
        <div>
            <button
                className={classNames}
                onClick={clickHandler}
                type='button'
                color={color}
            >
                <span>Сезон №{name}</span>
            </button>
        </div>
    </div>
}

export default SeasonCheckbox;